var map = {
	"./connection_lost.svg": 7210,
	"./email.svg": 615,
	"./error.svg": 2813,
	"./install-app.svg": 3648,
	"./max-black.svg": 5187,
	"./max.svg": 21,
	"./tg.svg": 7758,
	"./wa.svg": 4617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8003;